function initDayFinder() {
  var productLinks = [
    '/products/le-t-shirt-dimanche-femme-en-coton-bio-ivoire',
    '/products/le-t-shirt-lundi-femme-en-coton-bio-ivoire',
    '/products/le-t-shirt-mardi-femme-en-coton-bio-ivoire',
    '/products/le-t-shirt-mercredi-femme-en-coton-bio-ivoire',
    '/products/le-t-shirt-jeudi-femme-en-coton-bio-ivoire',
    '/products/le-t-shirt-vendredi-femme-en-coton-bio-ivoire',
    '/products/le-t-shirt-samedi-femme-en-coton-bio-ivoire',
  ];

  $('#dayfinder-form').on('submit', function (e) {
    e.preventDefault();
    $('#dayfinder-form .error').fadeOut();
    let year = parseInt($('#dayfinder-year').val());
    let month = parseInt($('#dayfinder-month').val());
    let day = parseInt($('#dayfinder-day').val());
    let inputDate = new Date(year, month, day);

    if (
      inputDate.getDate() !== day ||
      inputDate.getMonth() !== month ||
      inputDate.getFullYear() !== year
    ) {
      $('#dayfinder-form .error').show();
      return;
    }
    $('.dayfinder-images a.image-container')
      .first()
      .attr('href', productLinks[inputDate.getDay()]);
    $('.dayfinder-images img').fadeOut();
    $('.dayfinder-images img[data-day="' + inputDate.getDay() + '"]').fadeIn();
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $('#dayfinder-form button').offset().top + 30,
      },
      1000,
    );
  });

  $('#dayfinder-form input, #dayfinder-form select').on('input', () =>
    $('#dayfinder-form .error').fadeOut(),
  );
}

function defer(method) {
  if (window.jQuery) {
    method();
  } else {
    setTimeout(function () {
      defer(method);
    }, 50);
  }
}

defer(initDayFinder);
